import { toast } from "react-toastify";
import { AppServices } from "../../config/entities";
import { ITokenDto } from "../../dtos/identity/ITokenDto";
import { IChangePasswordDto } from "../../dtos/identity/IChangePasswordDto";

export class IdentityService {
  async login(
    username: string,
    password: string
  ): Promise<ITokenDto | undefined> {
    const body = {
      username,
      password,
    };

    const response = await AppServices.Axios.post(`/Identity/login`, body, {});
    if (response.status === 200) {
      return response.data;
    }
    return undefined;
  }

  async currentUser() {
    const response = await AppServices.Axios.get(`/Identity/currentUser`);
    console.log(response);
    // const responseDto = response.data;
    // return responseDto.data;
  }

  async userDetails() {
    const response = await AppServices.Axios.get(`/Identity/user-details`);
    console.log(response);
    // const responseDto = response.data;
    // return responseDto.data;
  }

  async getUserPhoto(userName: string): Promise<string | undefined> {
    try {
      const url = `/accounts/photo/${userName}`;
      const response = await AppServices.Axios.get(url);
      return response.data;
    } catch (e) {
      return undefined;
    }
  }

  async ChangePassword(data: IChangePasswordDto): Promise<boolean> {
    const body = { ...data };
    const response = await AppServices.Axios.post(
      `/Accounts/change-password`,
      body,
      {}
    );
    if (response.status !== 200) {
      toast.error("API error!");
      return false;
    }
    if (response.status === 200) {
      if (response.data.success === true) return true;
      toast.error(response.data.errorMessage);
    }
    return false;
  }
}
